import { Overlay } from '@angular/cdk/overlay';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
var ModalService = /** @class */ (function () {
    function ModalService(overlay) {
        this.overlay = overlay;
    }
    ModalService.prototype.open = function (templateRef) {
        this.close();
        this.overlayRef = this.overlay.create({
            hasBackdrop: false,
            panelClass: 'ap-stepper-overlay',
            scrollStrategy: this.overlay.scrollStrategies.block(),
            positionStrategy: this.overlay.position().global()
        });
        this.overlayRef.attach(templateRef);
    };
    ModalService.prototype.close = function () {
        if (this.overlayRef != null) {
            if (this.overlayRef.hasAttached()) {
                this.overlayRef.detach();
            }
            this.overlayRef.dispose();
        }
    };
    ModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(i0.ɵɵinject(i1.Overlay)); }, token: ModalService, providedIn: "root" });
    return ModalService;
}());
export { ModalService };
